import { render, staticRenderFns } from "./ComplaintForm.vue?vue&type=template&id=55be8071&scoped=true"
import script from "./ComplaintForm.vue?vue&type=script&lang=js"
export * from "./ComplaintForm.vue?vue&type=script&lang=js"
import style0 from "./ComplaintForm.vue?vue&type=style&index=0&id=55be8071&prod&lang=scss&scoped=true"
import style1 from "./ComplaintForm.vue?vue&type=style&index=1&id=55be8071&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be8071",
  null
  
)

export default component.exports